/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Generate_ButtonInputs */



/**
* | output |
* | --- |
* | "Generate Preview" |
*
* @param {Image_Export_Preview_Generate_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_generate_button = /** @type {((inputs?: Image_Export_Preview_Generate_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Generate_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generer la previsualisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau generieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Genera anteprima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать предварительный просмотр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generar vista previa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("生成预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューを生成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन उत्पन्न करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerar pré-visualização")
	return /** @type {LocalizedString} */ ("Generate Preview")
});